import { useCallback, useState } from 'react';

import { Chip } from '~components/generic/editor/Chip/Chip';
import { PenIcon } from '~components/icons/PenIcon';
import { SaveIcon } from '~components/icons/SaveIcon';
import styles from './EditComponents.module.css';

export const ChipSection = () => {
  const [hasLabel, setHasLabel] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [hasIcon, setHasIcon] = useState(false);
  const [hasPreIcon, setHasPreIcon] = useState(false);
  const [isClickable, setIsClickable] = useState(false);

  const handleChipClick = useCallback(e => {
    console.log('Chip clicked', e);
  }, []);

  return (
    <div className={styles.container}>
      <section>
        <h5>Chip</h5>
        <div className={styles.component}>
          <Chip
            label={hasLabel ? 'Click me' : undefined}
            disabled={isDisabled}
            processing={isProcessing}
            icon={hasIcon ? <SaveIcon /> : undefined}
            preIcon={hasPreIcon ? <PenIcon /> : undefined}
            onClick={isClickable ? handleChipClick : undefined}
          />
          <form>
            <label htmlFor="interactiveButtonHasLabel">Label: </label>
            <input
              type="checkbox"
              id="interactiveButtonHasLabel"
              checked={hasLabel}
              onChange={() => setHasLabel(!hasLabel)}
            />
            <br />
            <label htmlFor="interactiveButtonIsDisabled">Disabled: </label>
            <input
              type="checkbox"
              id="interactiveButtonIsDisabled"
              checked={isDisabled}
              onChange={() => setIsDisabled(!isDisabled)}
            />
            <br />
            <label htmlFor="interactiveButtonIsProcessing">Processing: </label>
            <input
              type="checkbox"
              id="interactiveButtonIsProcessing"
              checked={isProcessing}
              onChange={() => setIsProcessing(!isProcessing)}
            />
            <br />
            <label htmlFor="interactiveButtonHasIcon">Icon: </label>
            <input
              type="checkbox"
              id="interactiveButtonHasIcon"
              checked={hasIcon}
              onChange={() => setHasIcon(!hasIcon)}
            />
            <br />
            <label htmlFor="interactiveButtonHasPreIcon">PreIcon: </label>
            <input
              type="checkbox"
              id="interactiveButtonHasPreIcon"
              checked={hasPreIcon}
              onChange={() => setHasPreIcon(!hasPreIcon)}
            />
            <br />
            <label htmlFor="interactiveButtonIsClickable">IsClickable: </label>
            <input
              type="checkbox"
              id="interactiveButtonIsClickable"
              checked={isClickable}
              onChange={() => setIsClickable(!isClickable)}
            />
          </form>
        </div>
        <h6>All possible chip states</h6>
        <div className={styles.component}>
          <Chip label="Label" status="default" />
          <span> </span>
          <Chip label="Label" status="success" />
          <span> </span>
          <Chip label="Label" status="error" />
        </div>
        <div className={styles.component}>
          <Chip label="Label" _forceIdleState />
          <span> </span>
          <Chip label="Label" _forceHoverState />
          <span> </span>
          <Chip label="Label" _forceActiveState />
          <span> </span>
          <Chip label="Label" _forceDisabledState />
          <span> </span>
          <Chip label="Label" _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Chip label="Label" icon={<PenIcon />} _forceIdleState />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceHoverState />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceActiveState />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceDisabledState />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Chip label="Label" preIcon={<PenIcon />} _forceIdleState />
          <span> </span>
          <Chip label="Label" preIcon={<PenIcon />} _forceHoverState />
          <span> </span>
          <Chip label="Label" preIcon={<PenIcon />} _forceActiveState />
          <span> </span>
          <Chip label="Label" preIcon={<PenIcon />} _forceDisabledState />
          <span> </span>
          <Chip label="Label" preIcon={<PenIcon />} _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Chip icon={<PenIcon />} _forceIdleState />
          <span> </span>
          <Chip icon={<PenIcon />} _forceHoverState />
          <span> </span>
          <Chip icon={<PenIcon />} _forceActiveState />
          <span> </span>
          <Chip icon={<PenIcon />} _forceDisabledState />
          <span> </span>
          <Chip icon={<PenIcon />} _forceProcessingState />
        </div>
        <div className={styles.component}>
          <Chip label="Label" icon={<PenIcon />} _forceIdleState size="small" />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceHoverState size="small" />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceActiveState size="small" />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceDisabledState size="small" />
          <span> </span>
          <Chip label="Label" icon={<PenIcon />} _forceProcessingState size="small" />
        </div>
        <div className={styles.component}>
          <Chip icon={<PenIcon />} _forceIdleState size="small" />
          <span> </span>
          <Chip icon={<PenIcon />} _forceHoverState size="small" />
          <span> </span>
          <Chip icon={<PenIcon />} _forceActiveState size="small" />
          <span> </span>
          <Chip icon={<PenIcon />} _forceDisabledState size="small" />
          <span> </span>
          <Chip icon={<PenIcon />} _forceProcessingState size="small" />
        </div>
      </section>
    </div>
  );
};
